import AppProductPriceLegalNotice from 'apps/productPriceLegalNotice/desktop';

function initFreeShippingTooltip () {

	const container = document.querySelectorAll('.freeShippingTooltip');

	if (container) {

		container.forEach((el) => {

			const parentElement = el.parentElement;

			if (parentElement.innerText !== '') {

				const tooltipTrigger = parentElement.querySelector('.freeShippingTooltip_trigger');
				AppProductPriceLegalNotice(parentElement, tooltipTrigger, { evtType: 'click' }, '.freeShippingTooltip',
					'.freeShippingTooltip__content');

			}

		});

	}

}

export default initFreeShippingTooltip;
